import classNames from "classnames";
import { merge } from "lodash";
import React from "react";
import { buildThemeCssVars, THEME_DEFAULTS } from "./../../ricos-styles";
import {
  AccessibilityListener,
  getLangDir,
  GlobalContext,
  SPOILER_TYPE
} from "./../../wix-rich-content-common";
import viewerStyles from "../statics/rich-content-viewer-scss";
import rtlStyles from "../statics/rtl.rtlignore-scss";
import AddAnchors from "./components/AddAnchors";
import ContentTraverser from "./ContentTraverser";
const styles = { ...viewerStyles, ...rtlStyles };
const ContentViewer = (props) => {
  const {
    config = {},
    onHover,
    isMobile = false,
    addAnchors,
    onMouseOver = () => {
    },
    content,
    setRef,
    typeMappers,
    nodeViewRenderers,
    nodeViewDecorators,
    experiments = {},
    t
  } = props;
  const SpoilerViewerWrapper = config[SPOILER_TYPE]?.SpoilerViewerWrapper;
  const contextualData = getContextualData(props);
  const viewerClassName = classNames(styles.viewer, {
    [rtlStyles.rtl]: contextualData.textDirection === "rtl"
  });
  const themeWithDefaults = merge(
    {},
    isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
    contextualData.theme
  );
  const style = buildThemeCssVars(themeWithDefaults, content?.documentStyle ?? {});
  const dataId = { "data-id": "content-viewer" };
  return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { key: "RicosViewer", value: { experiments, isMobile, t } }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.wrapper),
      dir: contextualData.languageDir,
      onMouseEnter: (e) => onHover && onHover(e),
      onMouseOver,
      ref: setRef,
      style,
      ...dataId
    },
    props.devTools,
    /* @__PURE__ */ React.createElement("div", { className: viewerClassName }, /* @__PURE__ */ React.createElement(AddAnchors, { addAnchors }, /* @__PURE__ */ React.createElement(
      ContentTraverser,
      {
        content,
        typeMappers,
        context: contextualData,
        nodeViewRenderers,
        nodeViewDecorators,
        SpoilerViewerWrapper
      }
    ))),
    /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
  ));
};
const getContextualData = ({
  t,
  theme,
  isMobile = false,
  anchorTarget,
  relValue,
  customAnchorScroll,
  config,
  locale,
  disabled,
  seoMode,
  iframeSandboxDomain,
  textAlignment,
  experiments,
  textDirection,
  direction,
  helpers,
  onNodeClick,
  jsdomMode,
  baseUrl
}) => {
  return {
    t,
    theme: theme || {},
    isMobile,
    anchorTarget,
    relValue,
    customAnchorScroll,
    config,
    helpers: helpers || {},
    locale: locale || "en",
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick: config?.uiSettings?.disableRightClick,
    textAlignment,
    experiments,
    textDirection,
    languageDir: direction || getLangDir(locale),
    onNodeClick,
    jsdomMode,
    baseUrl
  };
};
var ContentViewer_default = ContentViewer;
export {
  ContentViewer_default as default
};
//# sourceMappingURL=ContentViewer.js.map
